module.exports = __webpack_public_path__ + "static/media/good-thieves.29eada48.md";